<template>
    <div
        v-show="!props.hide"
        :class="`uuid-${config.uuid}`"
    >
        <span class="text">{{ i18n(props.text) || i18nLabel }}</span>
        <i class="mobile-general-form-iconfont icon-sure" v-if="checked">&#xe05d;</i>
    </div>
</template>
<script>

import ComponentBase from '../component-base';
import { component } from './props';
export default {
    name: component,
    extends: ComponentBase,
    props: {
        activeRadio: {
            type: Object,
            default: null,
        },
    },
    computed: {
        checked() {
            return this.uuid === (this.activeRadio || {}).uuid;
        },
    },
};
</script>
<style lang="less" scoped>
.icon-sure {
    color: #FF8000;
}
</style>
